export default __webpack_public_path__ + "static/img/saml_logo.0111030.png";